import { useSelector } from '../../selectors/useSelector';

import PropertiesPage from '../PropertiesPage';
import { ZRAMPropertiesPage } from '../ZRAMPropertiesPage';

const PropertiesPageWrapper = () => {
  const user = useSelector((state) => state.user);

  if (user.isEnterpriseCustomer) {
    return <ZRAMPropertiesPage />;
  }

  return <PropertiesPage />;
};

export default PropertiesPageWrapper;
